import styled from "styled-components";

export const StylesRootContainer = styled.div`
  isolation: isolate;
  --main-color: #0076ff;
  --user-bubble-color: #eaf2ff;
  --text-color: #0d0a0a;
  --card-bg-color: #ffffff;
  --card-border-color: #e5e7eb;
  --font-family: "Figtree", sans-serif;
  --size: 2rem;

  --status-neutral-color: #9ca3af;
  --status-success-color: #22c55e;
  --status-warning-color: #f59e0b;
  --status-danger-color: #ef4444;

  --debug-panel-bg: #111827;
  --debug-panel-border: #374151;
  --debug-in: #22c55e;
  --debug-out: #38bdf8;
  --debug-system: #f59e0b;
  font-family: var(--font-family);
  position: fixed;
  bottom: 0;
  right: 0;
  width: 90vw;
  margin: 1.625rem 1.625rem;
  z-index: 9999;

  @media screen and (min-width: 30em) {
    width: 94vw;
  }

  @media screen and (min-width: 48em) {
    width: auto;
  }
`;
